module.exports = __webpack_public_path__ + "img/AstroFrens192.2a56b26e.jpg";